import { createApolloLink } from './apollo-link';
import { FILE_SERVICE_V2 } from './file-service.token';
import { FileService } from './file.service';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { Injector, Provider } from '@angular/core';
import { InMemoryCache } from '@apollo/client/core';
import { fileApiProviders } from '@app/file-api/file-api-providers';
import { NewRelic } from '@app/shared/services/newrelic.service';
import { environment } from '@src/environments/environment';
import { Apollo, APOLLO_NAMED_OPTIONS, type NamedOptions } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { GraphQLFormattedError } from 'graphql';

export const newFileInfraProviders: Provider[] = [
	{
		provide: APOLLO_NAMED_OPTIONS,
		// istanbul ignore next -- A module provider factory, maybe could add a tests later.
		useFactory(injector: Injector, httpLink: HttpLink): NamedOptions {
			const newrelic = injector.get(NewRelic);
			const { fileService, awsRegion } = environment;
			const { endpoint, identityPoolId } = fileService;

			return {
				fileApiClient: {
					defaultOptions: {
						// Default to no cache for all queries and mutations.
						query: { fetchPolicy: 'no-cache' },
						mutate: { fetchPolicy: 'no-cache' },
						watchQuery: { fetchPolicy: 'no-cache' },
					},
					cache: new InMemoryCache(),
					link: createApolloLink({
						httpLink,
						awsRegion,
						endpoint,
						identityPoolId,
						handleError: (message: string, error: Error | GraphQLFormattedError) => {
							newrelic.noticeError(error, { message });
							// eslint-disable-next-line no-console
							console.error(message, error);
						},
					}),
				},
			};
		},
		deps: [Injector, HttpLink],
	},
	HttpLink,
	Apollo,
	...fileApiProviders,
	FileService,
	{
		// Also provide via a provider token for better bundling.
		provide: FILE_SERVICE_V2,
		useClass: FileService,
	},
];

export const newFileInfraModuleProviders = [
	...newFileInfraProviders,
	provideHttpClient(withInterceptorsFromDi()),
];
